import * as React from 'react';
import { Box, Text } from '@wix/design-system';
import { Trans } from '@wix/wix-i18n-config';
import { RootStore, withInjectedRootStore } from 'providers';

const WixelVoucherBannerComp: React.FC<{ rootStore: RootStore }>= ({ rootStore }) => {
    const { biLogger, siteGuid, userGuid } = rootStore.appStore.appContext;

    React.useEffect(() => {
        biLogger.logCouponToastView({
            toastType: 'WixelLightCoupon',
            siteId: siteGuid,
            uuid: userGuid
        })
    }, []);

    return (
        <Box
            width="100%"
            backgroundColor="white"
            align="center"
            verticalAlign="middle"
            height="54px"
            boxShadow="0px -3px 28px 0px rgba(0, 0, 0, 0.09), inset 0px 1px 0px 0px #dfe5eb"
        >
            <Text size="medium" weight="thin">
                <Trans
                    i18nKey="premium-purchase-plan.purchase_flow.wixel_banner.free_light_plan"
                    components={{
                        strong: (
                            <Text
                                size="small"
                                weight="bold"
                            />
                        ),
                    }}
                />
            </Text>
        </Box>
    );
};

export const WixelVoucherBanner = withInjectedRootStore(WixelVoucherBannerComp);